import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const Login = Loadable({
  loader: () => import("./Login"),
  loading: Loading
})
